export default {
    "created": "Pontajul a fost creat cu succes",
    "updated": "Pontajul a fost actualizat cu succes",
    "deleted": "Pontajul a fost șters cu succes",
    "restored": "Pontajul a fost restaurat cu succes",
    'not_found' : 'Nici un pontaj nu a fost gasit.',
    'not_selected' : 'Nu ati selectat pontajul.',
}
